<template>
    <div class="flex-col">
        <vnavbar title="器械清点" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <div class="header">
            <div class="patient">
                <div class="name">{{surgeryInfo.patient_name}}</div>
                <div class="bed">{{surgeryInfo.sex||'--'}}/{{surgeryInfo.age||'--'}}/{{surgeryInfo.bed_no||'--'}}</div>
            </div>
            <div>
                <div class="more">
                    <div class="moredevice">{{surgeryInfo.surgeries}}</div>
                    <div @click="isShowMore=!isShowMore">查看更多<span><i
                                :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span></div>
                </div>
                <div v-if="isShowMore" class="surgery">
                    <div>台次:{{surgeryInfo.scheduled_sequence}}</div>
                    <div>手术间:{{surgeryInfo.dic_operating_room}}</div>
                    <div>科室:{{surgeryInfo.dic_section}}</div>
                    <div>术前诊断:{{surgeryInfo.plan_diseases}}</div>
                    <div>手术医生:{{surgeryInfo.surgeon}}</div>
                    <div class="time">手术计划开始时间:{{surgeryInfo.plan_time && this.$moment(surgeryInfo.plan_time).format(`YYYY-MM-DD
                        HH:mm:ss`)}}</div>
                </div>
            </div>
        </div>
        <vtabs class="tabcard" type="card" :style="{'margin-top':'2px','height':`${ this.screenHeight - 180}px`}" v-model="activeTabStageId">
            <vtab v-for="(tab, index) in countStage" :key="index" :title="tab.stage_name" :name="tab.id">
                <i v-if="activeStageIndex>0 && tab.allow_edit && tab.calculate_relation" @click="syncPrevData(activeStageIndex)" class="el-icon-refresh-right" style="float: right;font-size: 22px;
margin-right: 20px;padding: 10px 0px;color: #04A891;" title="同步上一步清点数据">同步</i>
                <div :style="{'height':`${ screenHeight - 210}px`}" style="overflow-y: scroll;">
                <vcell v-for="(item, idx) in instruments" :key="idx">
                    <template slot="title">
                        <div style="text-align: left;padding-left: 20px;">{{item.instrument_name}}</div>
                    </template>
                    <vstepper slot="right-icon" v-model="item.amount[activeStageIndex]" min="0" button-size="24px" input-width="38px"
                        class="absolute right14" />
                </vcell>
                </div>
            </vtab>
        </vtabs>
        <div class="bottom">
            <vbutton class="btnTrans" v-if="!activeStage.allow_edit" type="info" @click="createCountingNode">新增清点项</vbutton>
            <vbutton class="btnTrans" type="info" @click="SaveChanges">保存</vbutton>
        </div>
    </div>
</template>

<script>
import { CellGroup as vcellgroup, Cell as vcell, PullRefresh as vpullrefresh, Stepper as vstepper, Field as vfield, Tab as vtab, Tabs as vtabs, NavBar as vnavbar, Empty, Button as vbutton, Dialog, Tabbar as vtabbar, TabbarItem as vtabbaritem, Icon as vicon, Tag as vtag } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `CountInstrument`,
    components: { vcellgroup, vpullrefresh, vcell, vstepper, vfield, vtab, vtabs, vnavbar, Empty, vtabbar, vtabbaritem, vbutton, [Dialog.Component.name]: Dialog.Component, vicon, vtag },
    data() {
        let sessionSurgeryObj = sessionStorage.getItem(`surgeryInfo`)
        let sessionSurgeryInfo = sessionSurgeryObj && JSON.parse(sessionSurgeryObj) || null
        let sessionCountStageObj = sessionStorage.getItem(`countStage`)
        let sessionCountStage = sessionCountStageObj && JSON.parse(sessionCountStageObj) || null

        let countStages = this.$route.params.countStage || sessionCountStage
        let stageId = 0
        if (this.$route.params.activeTabStageId) {
            stageId = this.$route.params.activeTabStageId
        } else {
            stageId = countStages && countStages.length > 0 ? countStages[0].id : 0
        }
        let sessionPrevPath = sessionStorage.getItem(`prevPath`)
        return {
            surgeryId: this.$route.query.surgeryId && parseInt(this.$route.query.surgeryId) || 0,
            surgeryInfo: this.$route.params.surgeryInfo || sessionSurgeryInfo,
            prevPath: this.$route.params.prevPath || sessionPrevPath,
            countStage: countStages,
            loading: false,
            finished: true,
            refreshing: false,
            tabsGroup: [
            ],
            activeTabStageId: stageId,
            instruments: [],
            package_style: this.$root.PackageCountingType, // separated  combin
            isShowMore: false
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`]),
        activeStage() {
            return this.countStage && this.countStage.find(i => i.id == this.activeTabStageId)
        },
        activeStageIndex() {
            return this.countStage && this.countStage.findIndex(i => i.id == this.activeTabStageId)
        }
    },
    beforeRouteLeave(to, from, next) {
        sessionStorage.setItem(`surgeryId`, this.surgeryId)
        sessionStorage.setItem(`surgeryInfo`, JSON.stringify(this.surgeryInfo))
        sessionStorage.setItem(`countStage`, JSON.stringify(this.countStage))
        sessionStorage.setItem(`prevPath`, this.prevPath)
        next()
    },
    created() {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            if (this.activeTabStageId > 0) {
                this.loadCountings()
            }
        })
    },
    mounted() { },
    methods: {
        loadCountings() {
            let req = this.myaxios.post(
                `/api/Nursing/CountingContent/${this.package_style == `separated` ? `GetStagesDataSeparated` : `GetStagesData`}`,
                this.countStage.map(i => i.id)
            )
            req.then((data) => {
                let ct = _.map(data, (d, index) => {
                    d.group_id = d.use_package_id
                    d.group_name = `${d.use_package_id} ${d.use_package_name}`
                    d.item_id = d.instrument_id
                    d.item_name = d.instrument_name
                    return d
                })
                this.instruments = ct
            })
        },
        syncPrevData(activeStageIndex) {
            let that = this
            if (activeStageIndex != 0) {
                if (this.activeStage.calculate_relation) {
                    let stageIndexArr = []
                    _.forEach(this.activeStage.calculate_relation.split(`,`), i => {
                        let eventStage = that.countStage.find(o => o.dic_event_id == parseInt(i))
                        if (eventStage) {
                            stageIndexArr.push(eventStage.display_order)
                        }
                    })
                    _.forEach(this.instruments, item => {
                        let itemSum = 0
                        if (stageIndexArr.length > 0) {
                            _.forEach(stageIndexArr, index => {
                                itemSum += item.amount[index - 1]
                            })
                        }
                        item.amount.splice(activeStageIndex, 1, itemSum)
                    })
                }
            }
        },
        createCountingNode() {
            this.$router.push({ name: `CountInstrumentCreate`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, activeStage: this.activeStage, countStage: this.countStage, prevPath: this.prevPath } }).catch(err => err)
        },
        SaveChanges() {
            //  保存用户更改，成功刷新数据，失败不刷新
            let that = this
            let reqs = []
            let now = that.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            reqs.push(this.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${this.activeTabStageId}&dateTime=${now}`))
            let result = []
            _.forEach(this.instruments, instrument => {
                result.push({
                    stage_id: that.activeTabStageId,
                    dic_instrument_id: instrument.instrument_id,
                    amount: instrument.amount[that.activeStageIndex],
                    biz_use_package_id: instrument.group_id,
                    display_order: instrument.display_order
                })
            })
            reqs.push(this.myaxios.post(`/api/Nursing/CountingContent/SaveData`, result))
            this.myaxios
                .all(...reqs)
                .then(() => {
                    this.$message.success(`保存成功`)
                })
                .catch(e => {
                    alert(2222)
                })
        },

        back() {
            this.$router.push({ name: `CountingList`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, prevPath: this.prevPath } }).catch(err => err)
        },
        onLoad() { },
        onRefresh() {
            let that = this
            that.refreshing = false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_countinstrument`) {
                this.surgeryId = this.$route.query.surgeryId
                this.surgeryInfo = this.$route.params.surgeryInfo
            }
        },
        activeTabStageId: function(newUrl, oldUrl) {
            this.instruments = []
            this.loadCountings()
        }
    }
}
</script>
<style lang="less" scoped>
    @import '../mobile_common.css';

    .backbar {
        background-color: #04A891;
        border: unset !important;

        /deep/ .van-icon {
            color: #ffffff !important;
        }

        /deep/ .van-nav-bar__text {
            color: #ffffff !important;
        }

        /deep/ .van-nav-bar__title {
            color: #ffffff !important;
        }
    }

    .van-hairline--bottom::after {
        border-bottom-width: 0px !important;
    }

    .header {
        color: #ffffff !important;
        background: #04A891 !important;
        font-size: 14px;
        text-align: left;

        .patient {
            line-height: 23px;
            position: relative;
            display: -webkit-box;
            display: -webkit-flex;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            align-items: center;
            height: 46px;

            .name {
                padding: 0 20px;
                font-size: 17px;
            }
        }

        .surgery {
            border-top: 1px dashed #ffffff;
            display: -webkit-box;
            display: -webkit-flex;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            align-items: center;
            flex-wrap: wrap;

            div {
                width: 50%;
                height: 30px;
                line-height: 30px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-weight: 500;
                font-size: 16px;
                padding: 0 16px;
            }

            .time {
                flex-basis: 100% !important;
            }
        }

        .more {
            align-items: center;
            display: -webkit-box;
            display: -webkit-flex;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            align-items: center;
            justify-content: space-between;
            margin: 0 16px;
            padding-bottom: 10px;

            .moredevice {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-weight: 500;
                font-size: 16px;
                max-width: 80%;
            }
        }
    }

    .bottom {
        display: flex;
        position: fixed;
        bottom: 0px;
        width: 100%;

        .btnTrans {
            flex: 1;
            background: var(--primary-color, #009688);
            margin: 5px;
            height: 40px;
            padding: 0px 30px;
            color: #ffffff;
        }
    }
    .scrollContent {
        overflow-y: auto;
        overflow-x: hidden;
    }

    .content {
        display: flex;
        font-size: 20px;

        .panel {
            position: relative;
            width: 100%;
            padding: 0 16px;
            text-align: left;

            .monthday {
                position: absolute;
                left: -40px;
                top: 0px;
                opacity: 1;
                background: #fff;
                font-size: 18px;
            }

            .date {
                position: absolute;
                left: -40px;
                top: 8px;
                opacity: 1;
                background: #fff;
                font-size: 18px;
            }

            .step {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: start;
                font-size: 16px;
                color: rgba(102, 102, 102, 1);
            }

            .steprowone {
                flex-basis: 70%;
                font-weight: 500;
                font-size: 20px;
                color: var(--primary-color, #009688);
                line-height: 36px;
                height: 36px;
                text-align: left;
                font-style: normal;
                overflow-wrap: break-word;
                white-space: nowrap;
                margin-top: 1px;
            }

            .phone {
                background-color: #E0F2EE;
                border-radius: 50%;
                height: 24px;
                width: 24px;
                line-height: 24px;
                text-align: center;
            }

            .steprowtwo {
                flex-basis: 100%;
                margin-top: 5px;
            }

            .remark {
                flex-basis: 90%;
                padding: 5px 10px 10px 0px;
                background-color: rgba(245, 245, 245, 1);
                border-radius: 2px;
            }
        }
    }
    .tabcard /deep/ .van-tab{
        color: #04A891;
        border-right: 1px solid #04A891;
    }
    .tabcard /deep/ .van-tab--active{
        color: #fff;
        background-color: #04A891;
    }
    .tabcard /deep/ .van-tabs__nav--card{
        border: 1px solid #04A891;;
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/CountInstrument.vue